/**
 * Specialized TabContainer to offer grouping of tabs.  Tabs can actually be grouped in the base TabContainer by
 * simply assigning setId properties to the children.  This class extends this capability in the following ways:
 *
 * <ul>
 *    <li>Displays group headers in response to hovering over group member tab headers</li>
 *    <li>Support dragging entire groups</li>
 * </ul>
 *
 * @module MW/layout/GroupedTabContainer
 * @copyright Copyright 2015 The MathWorks, Inc.
 */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "MW/layout/GroupedTabBar",
    "MW/layout/LendingTabContainer"
], function (declare, lang, GroupedTabBar, LendingTabContainer) {

    /**
     * @class MW/layout/GroupedTabContainer
     * @classdesc Defines a TabContainer subclass that provides visual and interaction affordances for managing subsets
     * (groups) of the total set of tabs.
     */
    return declare([LendingTabContainer], {

        tabBarClass: GroupedTabBar,

        buildRendering: function () {
            // Forward info to tab bar
            this.inherited(arguments);
            this._tabBar.actionsMenuCreator = lang.partial(this.actionsMenuCreator, this);
            this._tabBar.groupPropertiesFetcher = this.groupPropertiesFetcher;
        },

        /*
         * Returns and array containing the subset of TabContainer children belonging to a specified set, nin order
         * of tab appearance.
         *
         * @returns {Array}
         * @instance
         */
        getSetMembersInTabOrder: function (setId) {
            var children = [];
            var widget, tabs, i;
            if (this._tabInfo.length === 1) {
                // If there is only one child it may not have a tab
                widget = this._tabInfo[0].widget;
                if (this.getChildProperties(widget).setId === setId) {
                    children.push(widget);
                }
            } else {
                tabs = this._tabBar.getButtonsInSet(setId);
                for (i = 0; i < tabs.length; i++) {
                    children.push(tabs[i].widget);
                }
            }
            return children;
        }
    });
});
